
import { SalaryTimeEntry } from "./types";
import { PDF_CONFIGS } from "./constants";
import { roundTo5Rappen } from "./formatters";

export const calculateDayTotalMinutes = (entries: SalaryTimeEntry[]): number => {
  return entries.reduce((acc, entry) => {
    if (!entry.end_time) return acc;
    const startTime = new Date(entry.start_time);
    const endTime = new Date(entry.end_time);
    return acc + (endTime.getTime() - startTime.getTime()) / (1000 * 60);
  }, 0);
};

export const calculateBreakTime = (totalHours: number): number => {
  return totalHours > PDF_CONFIGS.BREAK_THRESHOLD_HOURS ? PDF_CONFIGS.BREAK_DURATION_MINUTES : 0;
};

export const calculateEffectiveTotalAmount = (
  totalMinutes: number, 
  breakMinutes: number, 
  hourlyRate: number
): {
  effectiveTotalHours: number;
  grossAmount: number;
  ahvIvEo: number;
  netAmount: number;
} => {
  const effectiveTotalHours = (totalMinutes - breakMinutes) / 60;
  const grossAmount = roundTo5Rappen(effectiveTotalHours * hourlyRate);
  const ahvIvEo = roundTo5Rappen(grossAmount * PDF_CONFIGS.AHV_IV_EO_RATE);
  const netAmount = roundTo5Rappen(grossAmount - ahvIvEo);

  return {
    effectiveTotalHours,
    grossAmount,
    ahvIvEo,
    netAmount
  };
};
